import * as dataCollectionTypes from '../../consts/uam/dataCollectionTypes';
import {makeSelectIotDeviceData} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import backendService from '../app/backendService';
import uamClientService from './uamClientService';

const checkDataCollectionFlow = async () => {
    const isUamBackend = backendService.isUamBackend();

    if (!isUamBackend) return;

    const iotDevice = makeSelectIotDeviceData()(getState());
    const {device} = iotDevice || {};

    if (!device) return;

    await uamClientService.cancelSynchronizeData({dataCollectionType: dataCollectionTypes.DATA_COLLECTION_GLOBAL});
    await uamClientService.getAssets();

    const {isHolderConnected} = device || {};

    if (isHolderConnected) {
        await uamClientService.getAssets({isHolder: true});
    }
};

export default {
    checkDataCollectionFlow,
};
